import Vue from "vue";
import Vuetify from "vuetify/lib";

// Icons
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon.vue';
import BallIcon from '@/components/icons/BallIcon.vue';
import BellIcon from '@/components/icons/BellIcon.vue';
import BullsEyeIcon from '@/components/icons/BullsEyeIcon.vue';
import ChartsIcon from '@/components/icons/ChartsIcon.vue';
import CircleCheckIcon from '@/components/icons/CircleCheckIcon.vue';
import CircleErrorIcon from '@/components/icons/CircleErrorIcon.vue';
import CloseIcon from '@/components/icons/CloseIcon.vue';
import DashboardIcon from '@/components/icons/DashboardIcon.vue';
import FileIcon from '@/components/icons/FileIcon.vue';
import InfoIcon from '@/components/icons/InfoIcon.vue';
import InvoiceIcon from '@/components/icons/InvoiceIcon.vue';
import LogoutIcon from '@/components/icons/LogoutIcon.vue';
import NavIcon from '@/components/icons/NavIcon.vue';
import NewsIcon from '@/components/icons/NewsIcon.vue';
import PrognosisIcon from '@/components/icons/PrognosisIcon.vue';
import ShieldsIcon from '@/components/icons/ShieldsIcon.vue';
import TrashIcon from '@/components/icons/TrashIcon.vue';
import UserIcon from '@/components/icons/UserIcon.vue';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#26AB5E',
                secondary: '#BCC5CC',
                accent: '#FFC121',
                error: '#F83030',
            },
        },
    },
    icons: {
        values: {
            "icon-arrow-left": {
                component: ArrowLeftIcon,
                props: {
                    name: 'icon-arrow-left',
                },
            },
            "icon-ball": { // name of our custom icon
                component: BallIcon, // our custom component
                props: { // pass props to your component if needed
                    name: 'icon-ball',
                },
            },
            "icon-bell": {
                component: BellIcon,
                props: {
                    name: 'icon-bell',
                },
            },
            "icon-bullseye": {
                component: BullsEyeIcon,
                props: {
                    name: 'icon-bullseye',
                },
            },
            "icon-charts": {
                component: ChartsIcon,
                props: {
                    name: 'icon-charts',
                },
            },
            "icon-circle-check": {
                component: CircleCheckIcon,
                props: {
                    name: 'icon-circle-check',
                },
            },
            "icon-circle-error": {
                component: CircleErrorIcon,
                props: {
                    name: 'icon-circle-error',
                },
            },
            "icon-close": {
                component: CloseIcon,
                props: {
                    name: 'icon-close',
                },
            },
            "icon-dashboard": {
                component: DashboardIcon,
                props: {
                    name: 'icon-dashboard',
                },
            },
            "icon-file": {
                component: FileIcon,
                props: {
                    name: 'icon-file',
                },
            },
            "icon-info": {
                component: InfoIcon,
                props: {
                    name: 'icon-info',
                },
            },
            "icon-invoice": {
                component: InvoiceIcon,
                props: {
                    name: 'icon-invoice',
                },
            },
            "icon-logout": {
                component: LogoutIcon,
                props: {
                    name: 'icon-logout',
                },
            },
            "icon-nav": {
                component: NavIcon,
                props: {
                    name: 'icon-nav',
                },
            },
            "icon-news": {
                component: NewsIcon,
                props: {
                    name: 'icon-news',
                },
            },
            "icon-prognosis": {
                component: PrognosisIcon,
                props: {
                    name: 'icon-prognosis',
                },
            },
            "icon-shields": {
                component: ShieldsIcon,
                props: {
                    name: 'icon-shields',
                },
            },
            "icon-trash": {
                component: TrashIcon,
                props: {
                    name: 'icon-trash',
                },
            },
            "icon-user": {
                component: UserIcon,
                props: {
                    name: 'icon-user',
                },
            }
        }
    }
});
